import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { BaseNotesDto, SingleResponseModel } from '../../models/base/base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseNotesService extends BaseHttpService<BaseNotesDto> {
  private url = environment.baseUrl + this.getResourceUrl();

  constructor(private httpClinet: HttpClient) {
    super(httpClinet);
  }

  getResourceUrl(): string {
    return 'Notes';
  }

  GetByMenuAndRecordId(menuKey,pageParameter, recordId){
    let params = { menukey: menuKey, _pageparameter: pageParameter, recordid: recordId};
    return this.httpClinet.get<SingleResponseModel<BaseNotesDto[]>>(`${this.url}/GetByMenuAndRecordId`, { params: params });
  }

}
